/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import G6 from '@antv/g6';
import { Command, Behavior } from '../../types';
import { EditorPrivateContextProps, withEditorPrivateContext } from '../../hooks';

export interface RegisterProps extends EditorPrivateContextProps {
  name: string;
  config: Command | Behavior | Record<string, unknown>;
  extend?: string;
}
interface RegisterState {}

export class Register extends React.Component<RegisterProps, RegisterState> {
  static create = function create(type: string) {
    class TypedRegister extends Register {
      constructor(props: RegisterProps) {
        super(props, type);
      }
    }

    return withEditorPrivateContext(TypedRegister);
  };

  constructor(props: RegisterProps, type: string) {
    super(props);

    const { name, config, extend, commandManager } = props;

    switch (type) {
      case 'node':
        G6.registerNode(name, config, extend);
        break;

      case 'edge':
        G6.registerEdge(name, config, extend);
        break;

      case 'command':
        commandManager.register(name, config as Command);
        break;

      case 'behavior':
        G6.registerBehavior(name, config as Behavior);
        break;

      default:
        break;
    }
  }

  render() {
    return null;
  }
}

export const RegisterNode = Register.create('node');
export const RegisterEdge = Register.create('edge');
export const RegisterCommand = Register.create('command');
export const RegisterBehavior = Register.create('behavior');

export default Register;
